import React from "react";
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Label, Text, Customized } from "recharts";
import { DataCard } from "../../../surveys/tabulations/DataCard";

const COLORS = ['#d90429','#e76f51','#e9c46a','#a7c957','#0077b6'];

export const SatisfactionCharts = ({ data: { grafica, indicador, meta, cumplimiento, total }}) => {
	
    return (
        <> 
            <div style={{ background: '#F4F5F6', borderRadius: 6 }}>
                <Customized 
                    component={<span style={{ position: 'absolute', fontSize: 15, fontWeight: 600, margin: '5px 0px 0px 10px' }}
                >
                    Satisfacción</span>} 
                />

                {
                    grafica?.reduce((a, e) => a + e.value, 0) !== 0 ? (
                        <PieChart width={600} height={250} margin={{ top: 30, right: 0, bottom: 0, left: 0 }}>
                            <Pie
                                data={grafica}
                                cx={180}
                                cy={150}
                                startAngle={180}
                                endAngle={0}
                                innerRadius={60}
                                outerRadius={100}
                                fill="#8884d8"
                                paddingAngle={ 1 }
                                dataKey="value"
                                nameKey="name"
                                label={ e => <text style={{ fontWeight: 600, fontSize: 12 }} x={ e?.x } y={ e?.y } textAnchor='end'>{ e?.value }%</text> }
                                labelLine={ true }
                            >
                                { grafica.map((entry, index) => (
                                    <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]}  />
                                ))}
                                <Label value={ `Encuestas: ${ total }` } position='centerBottom' style={{ fontSize: 15, fontWeight: 600 }}fill="black" />
                            </Pie>
                                
                            <Legend content={ <RenderLegend colors={ COLORS } /> } verticalAlign="middle" />
                        </PieChart>
                    ) : (
                        <div style={{ height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <span style={{ fontWeight: 600, color: 'grey', fontSize: 14  }}>Sin datos</span>
                        </div>
                    )
                }
            </div>

            <div style={{ display: 'flex', gap: 5, margin: '10px 0px 10px 0px' }}>
                <DataCard 
                    title="Indicador" 
                    value={ indicador === 0 ? '-' : `${ indicador }%` } 
                    background="#E9EBED"
                    color="#212529"
                />

                <DataCard 
                    title={ `Meta ${ new Date().getFullYear() }` }
                    value={ `${ meta }%` } 
                    background="#E9EBED" 
                    color="#212529"
                />

                <DataCard
                    title="Desempeño" 
                    value={ indicador === 0 ? '-' : `${ cumplimiento }%` } 
                    background="#6c757d" 
                    color="#fff"
                />              
            </div>
        </>
    );
}

const RenderLegend = (props) => {

	const { payload, colors } = props;

	return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', paddingRight: 20 }}>
            <ul>
                {payload.map((entry, index) => (
                    <li style={{ color: colors[index] }} key={`item-${index}`}>
                        <span style={{ color: '#000', fontSize: 13, fontWeight: 600 }}>{entry.value}</span>
                    </li>
                ))}
            </ul>
        </div>
	);
}